import React, { useRef } from 'react';

/* gleiche Struktur wie im Grid ------------------------- */
export interface GridRow {
  Position: string;
  Aufwand: string;
  Einheit: string;
  Beschreibung: string;
  expanded?: boolean;
  formDataIndex: number;
}

interface Props {
  dataItem: GridRow;
  idx: number;
  commitAufwand: (value: string, idx: number) => void;
}

/**
 * Detail-Zeile fürs Mobile-Grid  
 *  • eigene Datei  → stabile Referenz, Grid mountet nicht neu  
 *  • ungecontrolled <input> + React.memo mit Custom-Compare  
 *    → selbst wenn der Grid neu rendert, bleibt diese
 *      Komponente UNANGETASTET.
 */
const MobileDetailRow: React.FC<Props> = ({ dataItem, idx, commitAufwand }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div style={{ padding: 5 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <strong style={{ minWidth: 50 }}>Aufwand:</strong>

        {/* Uncontrolled – kein State-Update → kein Grid-Re-Render */}
        <input
          ref={inputRef}
          defaultValue={dataItem.Aufwand}
          className="k-input"
          style={{ height: 32, width: 138 }}
          onBlur={e => commitAufwand(e.target.value, idx)}
          onKeyDown={e => e.stopPropagation()}   /* verhindert Grid-Shortcuts */
        />

        <span style={{ minWidth: 40, marginLeft: 18 }}>{dataItem.Einheit}</span>
      </div>
    </div>
  );
};

/* 🔒 Custom compare: nur neu rendern,
     wenn relevante Werte _wirklich_ geändert wurden */
export default React.memo(
  MobileDetailRow,
  (prev, next) =>
    prev.dataItem.Aufwand === next.dataItem.Aufwand &&
    prev.dataItem.Einheit === next.dataItem.Einheit &&
    prev.dataItem.Beschreibung === next.dataItem.Beschreibung
);
